export var PANCAKE_LIGHT = '5.0.0-light';
export var PANCAKE_DARK = '5.0.0-dark';
export var WAFFLE_LIGHT = 'waffle-light';
export var WAFFLE_DARK = 'waffle-dark';
export var WHITELABEL_LIGHT = 'whitelabel-light';
export var WHITELABEL_DARK = 'whitelabel-dark';
export var isPancake = designVersion => designVersion === PANCAKE_LIGHT || designVersion === PANCAKE_DARK;
export var isWaffle = designVersion => designVersion === WAFFLE_LIGHT || designVersion === WAFFLE_DARK;
export var isWhiteLabel = designVersion => designVersion === WHITELABEL_LIGHT || designVersion === WHITELABEL_DARK;
export var isDarkMode = designVersion => [PANCAKE_DARK, WAFFLE_DARK, WHITELABEL_DARK].includes(designVersion);
//# sourceMappingURL=index.js.map